import { StyleSheet } from 'react-native';

import { COLOR, blackTransparent, lightGrey } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        justifyContent: 'center',
        paddingLeft: 12,
        borderRadius: 2,
    },
    playing: {
        backgroundColor: COLOR.primary,
    },
    live: {
        backgroundColor: lightGrey(0.2),
    },
    unsubscribedOverlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.5),
    },
    webStickyProgramCell: {
        overflow: 'visible',
        /*
            On web `position: sticky` doesn't work when ancestor has `overflow: hidden`
            clip-path property is used to bypass the restriction
        */
        // @ts-ignore
        '-webkit-clip-path': 'inset(0)', // Safari
        'clip-path': 'inset(0)',
        clip: 'rect(0px, auto, auto, 0px)', // IE11/Edge
    },
    webStickyText: {
        // @ts-ignore
        position: 'sticky',
        alignSelf: 'flex-start',
        left: 6,
        // @ts-ignore
        overflow: 'clip',
        contain: 'paint',
    },
});

export default styles;
